import React from "react";
import { connect } from "react-redux";
import { compose } from "redux";
import { withRouter } from "react-router-dom";

import * as runReducer from "containers/Run/reducer";
import { getJobId } from "containers/CreateWizard/reducer";

import { getIsFeatureOpen, updateIsFeatureOpen, updateFeatureName } from "containers/Login/reducer";
import FeatureChartContainer from "containers/FeatureChart/FeatureChart";

import FieldFeatures from "components/FieldFeatures/FieldFeatures";

class FieldFeaturesContainer extends React.PureComponent {
  render() {
    const { id, history } = this.props;

    return <FieldFeatures {...this.props} featureChart={<FeatureChartContainer id={id} />} />;
  }
}

const mapDispatchToProps = (dispatch, ownProps) => ({
  updateIsFeatureOpen: (isOpen) => dispatch(updateIsFeatureOpen(isOpen)),
  updateFeatureName: (name) => dispatch(updateFeatureName(name)),
  updateFeatureSelection: (id, modelId) => dispatch(runReducer.updateFeatureSelection(id, modelId))
});

const mapStateToProps = (state, ownProps) => {
  const id = getJobId(state);
  const models = runReducer.getTransformedSortedModels(state, id);
  const bestModel = models && models.length > 0 ? models[0] : undefined;
  const chooseModel = runReducer.getTransformedChooseModel(state, id);

  return {
    id: id,
    isFeatureOpen: getIsFeatureOpen(state),
    model: chooseModel ? chooseModel : bestModel
  };
};

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export default compose(withConnect, withRouter)(FieldFeaturesContainer);
